export { default as ApplePay } from "./ApplePay";
export { default as BilletBank } from "./BilletBank";
export { default as Diamond } from "./Diamond";
export { default as Group } from "./Group";
export { default as Nupay } from "./Nupay";
export { default as Picpay } from "./Picpay";
export { default as Pix } from "./Pix";
export { default as PixBold } from "./PixBold";
export { default as StepCheck } from "./StepCheck";
